import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './components/page/page.component';
import { DragDropComponent } from './components/drag-drop/drag-drop.component';

const routes: Routes = [
  { path: '', redirectTo: '/trasparenza', pathMatch: 'full' },
  { path: 'admin/menu-drag-drop', component: DragDropComponent },
  { path: '**', component: PageComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
